import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import SessionFeedback from "./components/home/SessionFeedback";
import ScrollToTop from "./components/layout/ScrollToTop";
// import Registration from './components/layout/Registration';
import EventsLanding from "./components/events/EventsLanding";
import Reg2 from "./components/events/Reg2";
import ZipDownload from "./components/home/ZipDownload";
import Registration from "./components/loginAccount/Registration";
import Landing from "./landing/landing";

// import "./i18next";

function AppContent() {
  const location = useLocation();
  const hideLayout =
    location.pathname === "/" ||
    location.pathname.startsWith("/Feedback") ||
    location.pathname.startsWith("/events/Reg2/");
  return (
    <>
      {/* {!hideLayout && <Header />} */}
      <Routes>
        <Route path="/" element={<EventsLanding />}></Route>
        <Route path="/events" element={<Landing />}></Route>
        <Route path="*" element={<ErrorPage />}></Route>
        <Route path="/events/Reg2/:id" element={<Reg2 />}></Route>
        <Route path="/Registration/:id" element={<Registration />}></Route>
        {/* Previous route - Uid now comes from the validate-student-session response
        <Route
          path="/Feedback/:Uid/:Sid/:Kid"
          element={<SessionFeedback />}
        ></Route> */}
        <Route path="/Feedback/:Sid" element={<SessionFeedback />}></Route>
        <Route
          path="/ZipDownload/files/temp/download/:fileId/:email"
          element={<ZipDownload />}
        ></Route>
        {/* <Route path="/video" element={<Video />} ></Route> */}
      </Routes>
      {/* {!hideLayout && <Footer />} */}
    </>
  );
}

function App() {
  const basename = process.env.REACT_APP_BASENAME || "/";
  console.log("Basename:", basename);
  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <ScrollToTop />
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

function ErrorPage() {
  return (
    <React.Fragment>
      <h3>Error Page</h3>
    </React.Fragment>
  );
}

export default App;
